import { useEffect, useState } from "react";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { MdInstallMobile } from "react-icons/md";

type State = {
  show: boolean;
  installPrompt: any;
};

const initialState: State = {
  show: false,
  installPrompt: null,
};

const Pwa = () => {
  const [state, setState] = useState(initialState);

  useEffect(() => {
  if (window.localStorage.getItem("pwaDisabled")) {
    return;
  }

  const beforeInstallPromptHandler = (event: Event) => {
    event.preventDefault();
    setState({
      show: true,
      installPrompt: event,
    });
  };

  const appInstalledHandler = () => {
    disableInAppInstallPrompt();
  };

  window.addEventListener("beforeinstallprompt", beforeInstallPromptHandler);
  window.addEventListener("appinstalled", appInstalledHandler);

  // Cleanup - removendo os event listeners ao desmontar o componente
  return () => {
    window.removeEventListener("beforeinstallprompt", beforeInstallPromptHandler);
    window.removeEventListener("appinstalled", appInstalledHandler);
  };
}, []);

  function disableInAppInstallPrompt() {
    setState(initialState);
    window.localStorage.setItem("pwaDisabled", "true");
  }

  async function handleInstall() {
    if (!state.installPrompt) {
      return;
    }
    const result = await state.installPrompt.prompt();
    console.log(`Install prompt was: ${result.outcome}`);
    disableInAppInstallPrompt();
  }

  return (
    <div
      className="pwa-overlay"
      style={{
        display: state.show ? "flex" : "none",
      }}
    >
      <div className="pwa-container">
        <div>
          Instalar App?{" "}
          <button className="close" onClick={disableInAppInstallPrompt}>
            <AiOutlineCloseCircle
              color="var(--text-1)"
              cursor={"pointer"}
              size={25}
            />
          </button>
        </div>
        <div className="pwa-info">
          <img
            src="/android-chrome-512x512.png"
            alt="Logo Fatores AI"
            width="50px"
          />
          <p>Fatores AI</p>
        </div>
        <div className="buttons">
          <button
            className="btn btn-primary d-inline-flex align-items-center gap-8"
            onClick={handleInstall}
          >
            Instalar <MdInstallMobile size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Pwa;
